<template>
    <div>
        <span :class="preCls + 'filter-label'">分类名称</span>
        <Select v-model="filter.catalogId" :class="preCls + 'select-public-style'" transfer clearable @on-change="search">
            <Option v-for="(item, index) in catalogList" :value="item.id" :key="index">{{ item.title }}</Option>
        </Select>
        <table-tool-bar style="margin-top: 16px;">
            <template slot="left">
                <table-searcher v-model="filter.merchName" placeholder="请输入商品名称" style="margin-left: 10px;" @search="search"></table-searcher>
            </template>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
            highlight-row
            @on-row-click="rowClick"
            @on-row-dblclick="rowDblclick"
            @on-select-cancel="onSelectCancel"
        ></Table>
        <!-- 底部分页 -->
        <table-pager :total.sync="page.total" :pageSize.sync="filter.pageSize" :pageNo.sync="filter.pageNo" @change="fetch"></table-pager>
    </div>
</template>
<script>
import { type } from "_u/helper";
import { mapCell, pipeCell } from "_c/grid/renderCell";
import { merchChooseList } from "@/api/merch";
import { catalogList } from "@/api/merch";

const WINDOW_HEIGHT = document.body.clientHeight;
const PAGE_SIZE = 20;

export default {
    name: "SelectMerch",
    components: {},
    inject: {
        $modal: { default: null },
    },
    data() {
        return {
            loading: false,
            searchValue: "",
            mtHeight: 330,
            page: {
                total: 0,
                list: [],
            },
            filter: {
                nopage: 0,
                pageNo: 1,
                pageSize: PAGE_SIZE,
                catalogId: "",
                merchName: "",
            },
            rowId: "",
            selection: [],
            catalogList: [],
        };
    },
    props: {
        id: {
            type: [String, Number],
            default: "",
        },
    },
    computed: {
        columns() {
            return [
                {
                    type: "index",
                    title: "序号",
                    align: "center",
                    width: 60,
                },
                {
                    key: "merchName",
                    title: "商品名称",
                    align: "left",
                    minWidth: 160,
                },
                {
                    key: "catalogTitle",
                    title: "所属品类",
                    align: "center",
                    minWidth: 120,
                },
                {
                    key: "storeNum",
                    title: "库存",
                    align: "center",
                    minWidth: 100,
                },
                {
                    key: "soldNum",
                    title: "已售",
                    align: "center",
                    minWidth: 100,
                },
                {
                    key: "originalPrice",
                    title: "原价(元)",
                    align: "right",
                    minWidth: 120,
                    render: pipeCell("currency"),
                },
                {
                    key: "currPrice",
                    title: "现价(元)",
                    align: "right",
                    minWidth: 120,
                    render: pipeCell("currency"),
                },
            ];
        },
    },
    watch: {
        "filter.catalogId"(val) {
            if (this.id === "") {
                if (this.$cache.active === "mActMs") {
                    this.$cache.catalogIdMs = val;
                } else if (this.$cache.active === "mActTg") {
                    this.$cache.catalogIdTg = val;
                }
            }
        },
    },
    methods: {
        fetch() {
            console.log();
            this.loading = true;
            Promise.all([catalogList({ pageNo: 1, pageSize: 999 }), merchChooseList(this.filter)])
                .then((args) => {
                    var [catalogList, merchList] = args;
                    this.catalogList = catalogList.data.page.list;
                    merchList.data.page.list.forEach((v) => {
                        v.originalPrice /= 100;
                        v.currPrice /= 100;
                        v.catalogTitle = this.catalogList.find((c) => c.id === v.catalogId).title;
                    });
                    this.page.list = merchList.data.page.list;
                    this.page.total = parseInt(merchList.data.page.totalCount);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 搜索
        search() {
            this.filter.pageNo = 1;
            this.fetch();
        },
        // 单击
        rowClick(selection) {
            if (type(selection) != "array") {
                selection = [selection];
            }
            this.selection = selection;
        },
        // 双击
        rowDblclick(selection) {
            if (type(selection) != "array") {
                selection = [selection];
            }
            this.selection = selection;
            this.$modal.$emit("lookup-close", this.selection);
        },
        onSelectCancel(selection) {
            this.selection = [];
        },
        setCustomerData(data) {
            this.page.total = parseInt(data.page.totalCount);
            // 默认选中逻辑
            if (this.multiple) {
                data.page.list.forEach((row) => {
                    if (this.selection.find((el) => el.id == row.id)) {
                        return (row._checked = true);
                    }
                });
            } else {
                data.page.list.some((row) => {
                    if (this.selection.find((el) => el.id == row.id)) {
                        return (row._highlight = true);
                    }
                });
            }
            this.page.list = data.page.list || [];
            this.loading = false;
        },
    },
    created() {
        if (this.id === "") {
            if (this.$cache.active === "mActMs") {
                this.filter.catalogId = this.$cache.catalogIdMs || "";
            } else if (this.$cache.active === "mActTg") {
                this.filter.catalogId = this.$cache.catalogIdTg || "";
            }
        }
        let that = this;
        that.$modal.$on("lookup-open", (data) => {
            that.selection = [];
            data.forEach((v) => {
                that.selection.push({
                    id: v.value,
                    merchName: v.text,
                });
            });
            // 打开选择框
            that.$modal.beforeEnter((next) => {
                Promise.all([this.fetch()]).finally(() => {
                    next();
                });
            });

            // 关闭选择框
            that.$modal.onBtnClick("confirm", (next, options) => {
                // todo 返回默认选中的项目
                that.$modal.$emit("lookup-close", that.selection);
                next();
            });
        });
    },
    mounted() {
        var me = this;

        this.$watch(
            function() {
                return this.filter.pageNo + " " + this.filter.pageSize;
            },
            function() {
                this.fetch();
            }
        );
    },
};
</script>
